import {
    UserProfile,
    useBxpWebStargateClient
} from "@/libraries/bxp-web-stargate-client/src/index";

import { AsyncResult, useAsync } from "./use-async";

export function useMe(): AsyncResult<UserProfile | null> {
    const stargateClient = useBxpWebStargateClient();

    return useAsync(() => stargateClient.me({}), []);
}
